<template>
  <router-view></router-view>
</template>

<script>
export default {
  created() {
    const verifyForm = JSON.parse(localStorage.getItem("verifyForm"));
    if (!verifyForm) {
      this.$router.push("/hzmb-truck-hk-apply");
    }
  },
};
</script>

<style></style>
